import styled from '@emotion/styled';
import React, {FC, PropsWithChildren} from 'react';
import {Button} from '../Components';

const Background = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  padding: 16px;
  background-color: #0000007f;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  padding: 30px 20px 20px;
  width: 500px;
  display: flex;
  max-width: 100%;
  border-radius: 6px;
  background: #ffffff;
  font-size: 18px;
  flex-direction: column;
`;

const Buttons = styled.div`
  gap: 10px;
  display: flex;
  margin: 40px 0 0 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

interface OkCancelDialogProps {
  onOk: () => void;
  onCancel?: () => void;
  title?: string;
  okLabel?: string;
}

export const OkCancelDialog: FC<PropsWithChildren<OkCancelDialogProps>> = ({
  children,
  onOk,
  onCancel = () => {},
  title,
  okLabel = 'OK',
}) => {
  return (
    <Background onClick={onCancel}>
      <Content onClick={(e) => e.stopPropagation()}>
        {title && <div className="mb-3 text-lg font-medium text-[#33364b]">{title}</div>}
        {children}

        <Buttons>
          <Button size="small" variant="secondary" label="Cancel" onClick={onCancel} />
          <Button size="small" label={okLabel} onClick={onOk} />
        </Buttons>
      </Content>
    </Background>
  );
};
